import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  RadioGroupInput,
  CheckboxInput,
  TextInput
} from '../../../../shared/FormBuilder'

function Abdomen () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-offset-1 col-xs-4 nh-sub-head'>Normal</div>
        <div className='col-xs-5 nh-sub-head'>Abnormal</div>
      </div>
      <div className='row'>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            options={[
              {
                label: 'Soft',
                value: 'Soft'
              },
              {
                label: 'Firm',
                value: 'Firm'
              }
            ]}
            name={PEQuestionnaire.abdomenSoftOrFirm.name}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.abdomenTender.name}
            options={[
              {
                label: 'Non-Tender',
                value: 'Non-Tender'
              },
              {
                label: 'Tender',
                value: 'Tender'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.abdomenDistended.name}
            options={[
              {
                label: 'Non-Distended',
                value: 'Non-Distended'
              },
              {
                label: 'Distended',
                value: 'Distended'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.abdomenNoOrganomegalyANDorganomegaly.name}
            options={[
              {
                label: 'No Organomegaly',
                value: 'No Organomegaly'
              },
              {
                label: 'Organomegaly',
                value: 'Organomegaly'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.abdomenActiveBS.name}
            options={[
              {
                label: 'Active BS',
                value: 'Active BS'
              },
              {
                label: 'Hypoactive Sounds',
                value: 'Hypoactive Sounds'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.abdomenSuprapubicTenderness.name}
            options={[
              {
                label: 'No Suprapubic Tenderness',
                value: 'No Suprapubic Tenderness'
              },
              {
                label: 'Suprapubic Tenderness',
                value: 'Suprapubic Tenderness'
              }
            ]}
          />
        </div>
        <div className='col-xs-offset-1 col-xs-11 margin-top'>
          <CheckboxInput {...PEQuestionnaire.abdomenOther} />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.abdomenOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Abdomen
